import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {EntityType} from 'nutshell-graphql-types';
import type {
    GetCustomFields as GetCustomFieldsQuery,
    GetCustomFieldsVariables,
    GetCustomFields_customFields as CustomFields,
} from 'nutshell-graphql-types';

import GET_CUSTOM_FIELDS from '../queries/get-custom-fields.graphql';

export const useGetCustomFields = (
    entityType: EntityType
): {
    customFields: CustomFields;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetCustomFieldsQuery,
        GetCustomFieldsVariables
    >(GET_CUSTOM_FIELDS, {
        variables: {
            input: {
                entityType,
            },
        },
        fetchPolicy: 'cache-and-network',
    });

    const {customFields} = makeDataDangerous(data);

    return {
        customFields,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
